import { cn } from '../lib/utils';
import { Store } from 'lucide-react';

const PLATFORM_STYLES = {
  amazon: {
    logo: 'https://cdn.brandfetch.io/idawOgYOsG/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1747149760488',
  },
  etsy: {
    logo: 'https://cdn.brandfetch.io/idzyTAzn6G/w/800/h/379/theme/dark/logo.png?c=1bxid64Mup7aczewSAYMX&t=1731111014317',
  },
  alibaba: {
    logo: 'https://cdn.brandfetch.io/id_eF5X4DY/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1667576151285',
  },
  walmart: {
    logo: 'https://cdn.brandfetch.io/idoGsFQrHx/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1761183718064',
  },
  custom: {
    logo: null,
  },
};

export function PlatformBadge({ platform, className, size = 'md' }) {
  const key = (platform || 'custom').toLowerCase();
  const config = PLATFORM_STYLES[key] || PLATFORM_STYLES.custom;

  const imgSizeClass =
    size === 'sm' ? 'h-3' : size === 'lg' ? 'h-5' : 'h-4';

  // Special styling for custom: pill with text only
  if (!config.logo) {
    const pillPadding =
      size === 'sm' ? 'px-2 py-0.5 text-[10px]' :
      size === 'lg' ? 'px-3 py-1 text-xs' :
      'px-2.5 py-0.5 text-[11px]';

    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full border border-slate-300 bg-slate-100 text-slate-700 font-semibold',
          pillPadding,
          className
        )}
      >
        Custom
      </span>
    );
  }

  return (
    <div className={cn('inline-flex items-center', className)}>
      <img
        src={config.logo}
        alt={key}
        className={cn('object-contain w-auto', imgSizeClass)}
      />
    </div>
  );
}

